import React, { useEffect } from 'react';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import { trackMetaEvent, trackTikTokEvent } from 'util/analytics';

const Refund = () => {

  useEffect(() => {
     
      trackMetaEvent('Lead');
      trackTikTokEvent('SubmitForm');
    }, []);
  return (
    <React.Fragment>
      <Helmet htmlAttributes>
        <title>Language Academy</title>
      </Helmet>
      <Header />
      <div className="innerPage">
        <section className="bannerOuter">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 text-center">
                <div className="thankyou-inner">
                  <h2 className="header">
                    <b>
                      <i className="fa fa-check-circle" aria-hidden="true"></i>
                      &nbsp;&nbsp;Thank You!
                    </b>
                  </h2>
                  <p>
                    Your data submitted successfully
                    <br />
                  </p>
                </div>
                <span></span>
                <br />
              </div>
            </div>
          </div>
        </section>
      </div>
      <section id="pte-modules" className="mt-5">
        <div className="container">
          <div className="row text-center"></div>
        </div>
      </section>
      <Footer />
    </React.Fragment>
  );
};

export default Refund;